import { UAParser } from "ua-parser-js";

// Utility methods extracted from pwa-install library
export class PWAUtils {
    static isAppleMobile(): boolean {
        const ua = navigator.userAgent || "";
        const platform = navigator.platform || "";
        const maxTouchPoints = navigator.maxTouchPoints || 0;

        const isIOSDevice =
            /iPad|iPhone|iPod/.test(ua) ||
            (platform === "MacIntel" && maxTouchPoints > 1); // iPadOS

        const supportsSW = "serviceWorker" in navigator;

        return isIOSDevice && supportsSW;
    }

    static isAppleDesktop(): boolean {
        const userAgent = navigator.userAgent.toLowerCase();
        if (navigator.maxTouchPoints || !userAgent.match(/macintosh/))
            return false;

        const version = /version\/(\d{2})\./.exec(userAgent);
        if (!version || !version[1] || !(parseInt(version[1]) >= 17))
            return false;

        const audioCheck = document
            .createElement("audio")
            .canPlayType('audio/wav; codecs="1"');
        const webGLCheck = new OffscreenCanvas(1, 1).getContext("webgl");
        return !!(audioCheck && webGLCheck);
    }

    static deviceFormFactor(): "narrow" | "wide" {
        return window.matchMedia("(orientation: portrait)").matches
            ? "narrow"
            : "wide";
    }

    static isStandalone(): boolean {
        return (
            window.matchMedia("(display-mode: standalone)").matches ||
            (navigator as any).standalone === true
        );
    }

    static isInstagram(): boolean {
        const { browser } = UAParser();
        return browser.is("instagram");
    }

    static isMobile(): boolean {
        const { device } = UAParser();
        return device?.type === "mobile" || device?.type === "tablet";
    }

    static getIOSVersion(): number | null {
        const ua = navigator.userAgent;
        const match = /OS (\d+)[_.](\d+)/.exec(ua);
        if (match) return parseFloat(`${match[1]}.${match[2]}`);
        return null;
    }

    static getBrowserName(): "safari" | "chrome" | "firefox" | "edge" | "other" {
        const ua = navigator.userAgent;
        if (/CriOS/.test(ua)) return "chrome";
        if (/FxiOS/.test(ua)) return "firefox";
        if (/EdgiOS/.test(ua)) return "edge";
        if (/Safari/.test(ua) && !/CriOS|FxiOS|EdgiOS/.test(ua))
            return "safari";
        return "other";
    }

    static needsSafariOnly(): boolean {
        const version = PWAUtils.getIOSVersion();
        return version !== null && version < 16.4;
    }
}
